import { FormControl, FormGroup } from '@angular/forms';
import { UUID } from 'symbols';
import { NomenclatureModel } from '../storage/symbols';

export interface ReceiptModel {
  id?: UUID;
  count: number;
  createdAt?: string;
  wholesale?: number;
  nomenclature: NomenclatureModel;
  nomenclatureId: string;
  price: number;
  type: ReceiptType;
}

export interface ReceiptContainerModelExpectBackend {
  id?: UUID;
  isChanged?: boolean;
  isNew?: boolean;
}

export interface ReceiptContainerModel {
  id?: UUID;
  createdAt: string;
  docNumber: number;
  receipts?: ReceiptModel[];
  orderId?: UUID;
  talonId?: UUID;
  standId?: UUID;
  invoiceId?: UUID;
  isChanged?: boolean;
  isNew?: boolean;
}

export interface ReceiptFormGroup {
  id: FormControl<string | null>;
  createdAt: FormControl<string | null>;
  count: FormControl<number>;
  price: FormControl<number>;
  wholesale: FormControl<number>;
  wholesaleTotal: FormControl<number>;
  total: FormControl<number>;
  nomenclatureId: FormControl<string>;
  nomenclature: FormGroup<any>;
}


export const initReceipts = (receipt: ReceiptModel): FormGroup<ReceiptFormGroup> => {
  return new FormGroup({
    id: new FormControl(receipt.id),
    createdAt: new FormControl(receipt.createdAt),
    count: new FormControl(receipt.count),
    price: new FormControl(receipt.price),
    wholesale: new FormControl(receipt.wholesale),
    wholesaleTotal: new FormControl(receipt.count * receipt.wholesale),
    total: new FormControl(receipt.count * receipt.price),
    nomenclatureId: new FormControl(receipt.nomenclatureId),
    nomenclature: new FormGroup({
      id: new FormControl(receipt.nomenclature?.id),
      name: new FormControl(receipt.nomenclature?.name),
      locationId: new FormControl(receipt.nomenclature?.locationId),
      price: new FormControl(receipt.nomenclature?.price),
      wholesale: new FormControl(receipt.nomenclature?.wholesale),
      payment: new FormControl(receipt.nomenclature?.payment)
    })
  });
};


export interface PosRes {
  method: string;
  step: number;
  params: {
    code: string;
    responseCode: string;
  };
  error: boolean;
  errorDescription: string;
}

export enum ReceiptType {
  IN = 'in',
  OUT = 'out',
  RETURN = 'return',
}


export const ReceiptTypeRelationName = {
  [ReceiptType.IN]: 'Надходження',
  [ReceiptType.OUT]: 'Витрата',
  [ReceiptType.RETURN]: 'Повернення',
}

export const TRAFFIC_LOCAL_STORAGE_KEY = 'traffic_local_storage';
